export enum AdobeAnalyticsConstants {
  InternalSearchGlobal = 'internsøk globalt',
  Kontaktskjema = 'kontaktskjema',
  Submit = 'submit',
  InternalSearch = 'internal search',
  SearchClickThrough = 'search click through',
  UseTool = 'use tool',
}
